import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const AgreementTransferWrapper = styled.div`
  h1 {
    font-weight: 700;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-top: 32px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    flex-direction: row;
    gap: 48px;
  }
`;

export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 732px;
  width: 100%;
  a {
    max-width: 272px;
  }
`;

export const Sidebar = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) and (max-width: calc(${({
      theme,
    }) => theme.breakpoints.medium} - 1px)) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 32px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    display: flex;
    flex-direction: column;
    width: 344px;
    flex-shrink: 0;
  }
`;

export const OptionsList = styled.ul`
  padding-left: 24px;
`;

export const OptionItem = styled.li`
  margin-top: 24px;
`;

export const InfoList = styled.ul`
  list-style: disc;
  padding-left: 24px;
  margin: 0;

  li {
    font-size: 16px;
    line-height: 24px;
    color: ${({ theme }) => theme.colors.textSecondaryGrey90};
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const Steps = styled.ol`
  padding-left: 18px;
  margin: 26px 0;
`;

export const StepTitle = styled.div`
  font-weight: 700;
  line-height: 24px;
`;

export const StepLink = styled(Link)`
  color: ${({ theme }) => theme.colors.textLinkLinkSecondary2100};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-decoration: underline;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 64px;
`;
